/**
 * @fileoverview Live controls companion view for the Zoom app.
 *
 * Shows personalized live controls and coaching for each meeting participant.
 * The full meeting view (agenda, participants, outputs) is on the screenshare —
 * the Zoom app serves as a per-user control surface.
 *
 * @module components/HostView
 */

import React from "react";
import LiveControlsPanel from "./LiveControlsPanel";
import ContentSharingPanel from "./ContentSharingPanel";
import { useMeetingState } from "../context/MeetingStateContext";
import config from "../config";

function HostView() {
  const { getMeetingId, insightsToken } = useMeetingState();
  const meetingId = getMeetingId() ?? '';
  const token = insightsToken ?? config.dashboardToken ?? '';

  return (
    <div id="app">
      <LiveControlsPanel />
      {meetingId && token && (
        <ContentSharingPanel meetingId={meetingId} token={token} />
      )}
    </div>
  );
}

export default HostView;
